exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".flexParent {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  margin-bottom: 70px;\n  margin-top: 50px;\n}\n@media only screen and (max-width: 518px) {\n  .panel-default {\n    width: 100%;\n  }\n}\n.flexChild {\n  width: 50%;\n  text-align: center;\n  max-width: 600px;\n}\n\n.product_heading:hover {\n  cursor: pointer;\n}\n\n.panel-heading {\n  text-align: center;\n  margin-top: 0.4em;\n  font-size: 2em;\n  color: darkblue;\n}\n.checkout_body {\n  text-align: center;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/functional_components/cart/cart.component.css
// module id = 59
// module chunks = 1